import { ResponsiveImageHtml } from './responsive-image-html';

export enum TalonOneWebCode {
  T1ODISCOUNT = 'T1ODISCOUNT',
  T1LDISCOUNT = 'T1LDISCOUNT',
  T1LREBATE = 'T1LREBATE',
  T1COUPON = 'T1COUPON',
  T1VOUCHER = 'T1VOUCHER',
}

export enum ShippingServiceIds {
    FreeShippingService = 'FREE_SHIPPING',
    ProfusionShippingService = 'PROFUSION_DISCOUNTED_SHIPPING'
}

// TODO: This model is very outdated, remove unused fields + add new ones.
export interface CartSummary {
  totalSavings: number;
  unbundledSavings: number;
  unbundledSubtotal: number;

  Subtotal: number;
  GrandTotal: number;
  DisplayShipping: boolean;
  DisplayCoupon: boolean;
  Discount: number;
  TaxesTotal: number;
  Shipping: ShippingDetails;
  Taxes: {
    TaxRate: TaxRate[];
    Pending: boolean;
    TaxesTotal: number;
  };
  FeesTotal: number;
  TotalPending: boolean;
  /** Checkout Page Fields */
  CheckoutPage: boolean;
  CustomerComments: string;
  RequireTerms: boolean;
  RequireDropshipTerms: boolean;
  AcceptedTerms: boolean;
  AcceptedDropshipTerms: boolean;
  PaymentMethods: CartSummaryPaymentMethods[];
  DisplayPickup: boolean;
  DisplayPickupValue: string;
  CheckoutBtn: boolean;
  TalonOne: {
    InEffect: boolean;
    CouponCode: string;
    CampaignId: number;
    Rules: string[];
    RuleSetId: number;
    RuleName: string;
    DealDescription: string;
    EffectTyoe: string;
  };
}

export interface CartSummaryPaymentMethods {
  Label: string;
  SubLabel: string;
  Kind: string;
  Text: string;
}

export interface TaxRate {
  TaxName: string;
  TaxCost: number;
}

export interface PickupDelivery {
  DeliveryMode: DeliveryMode.Curbside | DeliveryMode.Pickup;
  LocationCode: string;
  // to be used on UI as composite key
  PickupLocationKey: string;
}

export interface StoreLocation {
  LocationID: any;
  LocationCode: string;
  SiteID: number;
  IsPickupLocation: boolean;
  IsWarehouseLocation: boolean;
  IsRentalLocation: boolean;
  IsCurbSideLocation: boolean;
  InventoryAvailability: boolean;
  LocationName: string;
  ImageUrl: string;
  Address: string;
  City: string;
  StateProv: string;
  PostalCode: string;
  Phone: string;
  Email: string;
  MapLink: string;
  Priority?: number;
  GeoLat?: number;
  GeoLng?: number;
  ContactUrl: string;
}

export interface StoreLocationsExt extends StoreLocation {
  LocationExtCode: string;
  IsAlerts: boolean;
  IsSelected: boolean;
}

export interface StorePickupMsg {
  LocationName: LocationName;
  IsAlert: boolean;
  Msg: string[];
}

export interface CartData {
  itemCount: number;
  CartID: string;

  CartItems: ProductItem[];
  BundleSets: BundleSet[];
  UnBundledItems: ProductItem[];
  CartSummary: CartSummary;
  Message: string;
  Currency: {
    CurrencyID: number;
    Name: string;
    CurrencyCode: string;
    Rate: number;
    DisplayLocale: string;
    CustomFormatting: string;
    CurrencySymbol: string;
    LimitedToStores: boolean;
    Published: boolean;
    DisplayOrder: number;
    DateCreated: Date;
    DateUpdated: Date;
  };
  EmptyLayout: any[];
  IsUser: boolean;
  OrderLevelPromotions: TalonOneItem[];
  PromoNotifications: EffectNotification[];
  CartBundleEditables: CartBundleEditable[];
  ShippingDetails: ShippingDetails;
}

export interface ShippingAddress {
  Name: string;
  Address: string;
  Address2: string;
  City: string;
  ProvinceCode: string;
  ProvinceName: string;
  CountryCode: string;
  CountryName: string;
  PostalCode: string;
  Phone: string;
}

export interface ConsolidatedShippingRate {
  ConsolidatedShippingRateId: string;
  ShippingCompany: string;
  ShippingCompanyId: string;
  ShippingService: string;
  ShippingServiceId: string;
  CustomerShippingCost: number;
  CustomerInsuranceCost: number;
  EstimatedDeliveryDays: number;
  Metadata: string;
}

export interface ShippingFulfillmentStrategy {
    HasNoShippingItems: boolean;
    HasDropshipItems: boolean;
    ImmediateShippingAvailableItems: string[];
    UnableToImmediatelyShipItems: string[];
    NoShippingItems: string[];
    DropshipQuoteRequiredItems: string[];
}

export interface ShippingDetails {
  ConsistsEntirelyOfDigitalItems: boolean;
  IsPickup: boolean;
  RequestInsurance: boolean;
  IsPickupDisabled: boolean;
  UnableToInstantQuote: boolean;
  PickupLocationCode: string;
  SelectedConsolidatedShippingRateId: string;
  ShippingQuote: ShippingQuote;
  CustomerShippingCost: number;
  CustomerInsuranceCost: number;
  HasGeocodeError: boolean;
  InsuranceError: string;
}

export interface ShippingQuote {
  QuoteId: string;
  ShippingAddress: ShippingAddress;
  ConsolidatedShippingRates: ConsolidatedShippingRate[];
  IsEligibleForInsurance: boolean;
  FulfillmentStrategy: ShippingFulfillmentStrategy;
}

export enum DeliveryMode {
  Shipping = 'Shipping',
  Pickup = 'Pickup',
  Curbside = 'Curbside',
}

export class CartMoveItem {
  From: string;
  To: string;
  RecordID: string;
}

export interface Item {
  RecordID: string;
  Webcode: string;
  CartID: string;
  ShoppingCartType: string;
  InventorySourceType: string;
  Description: string;
  UnitPrice: number;
  Taxable: boolean;
  PSTExempt: boolean;
  ShippingExempt: null;
  ParentRecordID: null;
  IsPromotion: boolean;
  IsOrderLevelPromotion: boolean;
  Manufacturer?: string;
  Quantity: number;
  CategoryLevel1?: string;
  CategoryLevel2?: string;
  CategoryLevel3?: string;
  CategoryLevel4?: string;
}
export interface ProductItem extends Item {
  IsDigitalItem: boolean;
  LineTotal: number;
  RecordID: string;
  Webcode: string;
  DisplayMin: boolean;
  ServicePlans: ServicePlan[];
  CartID: string;
  ShoppingCartType: string;
  InventorySourceType: string;
  Manufacturer: string;
  Description: string;
  UnitPrice: number;
  Quantity: number;
  ParentItem: string;
  ItemStatus: string;
  RentalStartDate: null;
  RentalEndDate: null;
  Taxable: boolean;
  PSTExempt: boolean;
  ShippingExempt: null;
  ParentRecordID: null;
  ImageDataburst: string;
  ItemFeatures: string;
  Attributes: Attributes;
  RebateAmounts: any[];
  ItemUrl: string;
  SkuMessage: null;
  StockingStatus: string;
  ItemWeight: number;
  FinalSale: boolean;
  RentalData: null;
  ExtendedText: null;
  SalesCode: null;
  EventGroup: null;
  InStoreDeal: boolean;
  NoShipping: boolean;
  StoreQuantities: { [key: string]: number };
  DiscountTotal: number;
  DiscountItems: ItemDiscountTalonOneItem[];

  /* not mapped */
  IsLastAnchorItem: boolean;
}

export interface TalonOneItem extends Item {
  RecordID: string;
  Webcode: string;
  CartID: string;
  ShoppingCartType: string;
  InventorySourceType: string;
  Description: string;
  UnitPrice: number;
  Quantity: number;
  Taxable: boolean;
  PSTExempt: boolean;
  ShippingExempt: null;
  ParentRecordID: null;
  Attributes: TalonOneAttributes;
}

export interface ItemDiscountTalonOneItem extends TalonOneItem {
  Attributes: ItemDiscountTalonOneCartItemAttributes | IRebateTalonOneCartItemAttributes;
}

export interface Attributes {
  IsAccessoryPrice: null;
  AccessoryParent: null;
  UnitOfMeasure: string;
  EventAttendee: null;
  RegularPrice: number;
  RentalOptions: null;
  IsFreeAllowed: null;
  IsBundleFreeItem: null;
  BundleId: number;
  IsBundleAnchor: boolean;

  // For GIFTVAR and EGIFTVAR Gift Cards Only
  GiftCardRecipientName?: string;
  GiftCardRecipientEmail?: string;
  GiftCardPrice?: number;
  GiftCardMessage?: string;
}

export interface TalonOneAttributes {
  TriggerCoupon: string;
  TriggerCouponId: number;
  CampaignId: number;
  RuleSetId: number;
  RuleName: string;
  SessionId: string;
}

export interface ItemDiscountTalonOneCartItemAttributes extends TalonOneAttributes {
  TotalDiscount: number;
  ProductWebCode: string;
}

export interface IRebateTalonOneCartItemAttributes extends TalonOneAttributes {
  ClaimableAmount: number;
  ProductWebCode: string;
}

export interface ItemMinimalDetails {
  NoShipping: boolean;
  CallForPricing: boolean;
  StockStatus: string;
  OnSale: boolean;
  DiscountAmount: number;
  Clearance: boolean;
  ReviewStars: number;
  InStock: boolean;
  ReviewCount: number;
  Webcode: string;
  Manufacturer: string;
  ProductUrl: string;
  AbsoluteUrl: string;
  ItemStatus: string;
  Description: string;
  SellingPrice: number;
  SellingPriceFormatted: string;
  Categories: string[];
  ImageDataburst: string;
  ImageHtml: ResponsiveImageHtml;
  AltImageHtml: ResponsiveImageHtml;
}

export interface AddToCartConfirmationDTO extends ItemMinimalDetails {
  FreeItems: ItemMinimalDetails[],
  ServicePlans: ServicePlan[];
}

export interface ServicePlan {
  ResourceCode: string;
  Description: string;
  Price: number;
  PriceFormatted: string;
  ImageDataburst: string;
  ShortCopy: string;
  Webcode: string;
}

export type ShippingCost = number | 'Pending' | 'Quote' | 'FREE';

export enum WarehouseLocationCode {
  Calgary = 'CALGARY',
  Edmonton = 'EDMONTON',
  Mississauga = 'MISSISSAUGA',
  Ottawa = 'OTTAWA',
  Toronto = 'TORONTO',
  Tradeshow = 'TRADESHOW',
}

export enum LocationName {
  ProFusionExpo = 'ProFusion Expo',
  VistekCalgary = 'Vistek Calgary',
  VistekEdmonton = 'Vistek Edmonton',
  VistekMississauga = 'Vistek Mississauga',
  VistekOttawa = 'Vistek Ottawa',
  VistekToronto = 'Vistek Toronto',
}

export enum PaypalPage {
  Cart = 'cart',
  Payments = 'payments',
  Checkout = 'checkout',
}

export interface NotificationProps {
  NotificationType: string;
  Title: string;
  Body: string;
}
export interface EffectNotification {
  EffectType: EffectNoficationType;
  Coupon: string;
  RuleName: string;
  CampaignId: number;
  RulesetId: number;
  RuleIndex: number;
  Props: {
    NotificationType: NotificationType;
    Title: string;
    Body: string;
  };
}

export const enum NotificationType {
  Info = 'Info',
  Offer = 'Offer',
  Error = 'Error',
  Misc = 'Misc',
}

export const enum EffectNoficationType {
  Removed = 'Removed',
  Rejected = 'Rejected',
  ShowNotification = 'ShowNotification',
}

export interface BundleSet {
  BundleId: number;
  Items: ProductItem[];
  ItemsCount: number;
  TotalSavings: number;
  Total: number;
}

export interface CartBundleEditable {
  BundleId: number;
  IsEditable: boolean;
}

export interface AddToCartWithAttributesPayload
{
  type: string;
  source: string;
  webCode: string;
  quantity: number;
  attributes: Attributes
}
